// removed by extract-text-webpack-plugin
module.exports = {"container":"d1M1C","body":"_Bln1","social-actions":"_2tVh1","copy-url-action":"_3nvU3","copy-url":"_3QCBL","facebook-container":"tHCBw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SharePrompts/SharePrompts.scss
// module id = ./src/components/SharePrompts/SharePrompts.scss
// module chunks = 4